module.exports = __webpack_public_path__ + "static/media/bug_icon.ddb0dd30.png";